import { Map, Record } from "immutable";

import AssigneeSectionStat from "./SectionStat";
import AssigneeQuestionStat from "./QuestionStat";
import AssigneeAggregatedStats from "seneca-common/features/assignments/features/teacher-assignments/state/models/Assignee/AggregatedStats";

export type AssigneeType = {
  status?: string;
  aggregatedStats?: AssigneeAggregatedStats;
  sectionStats?: Map<string, AssigneeSectionStat>;
  questionStats?: Map<string, AssigneeQuestionStat>;
};

export const defaultAssignee: AssigneeType = {
  status: undefined,
  aggregatedStats: undefined,
  sectionStats: Map<string, AssigneeSectionStat>(),
  questionStats: Map<string, AssigneeQuestionStat>()
};

export default class Assignee extends Record(defaultAssignee) {}
